var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":"https://storage.googleapis.com/fit20app-4-acctest.appspot.com/static/images/fit20-spiner-logo.png"}})])
}]

export { render, staticRenderFns }